// extracted by mini-css-extract-plugin
export default {"header":"StructuredAnalysisView_header__RWFok","calloutBox":"StructuredAnalysisView_calloutBox__av3L7"};